import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from '../ModuleBlock';
import ModuleService from '../../../../../services/module';

class GamificationModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
    };

    render() {
        return (
            <ModuleBlock
                app={this.props.app}
                module={ModuleService.getModule(ModuleService.GAMIFICATION)}
            />
        );
    }
}

export default GamificationModuleBlock;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/GamificationModuleBlock/GamificationModuleBlock.js